import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";

function useReportWidgetService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getChartWithFilter = (id: string, filter: object) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ReportWidgetClient.GetByFilter(id, filter)
      .then((res) => res.data);
  };

  return { getChartWithFilter };
}

export default useReportWidgetService;
